import { render } from "./MastZugaenglichkeit.vue?vue&type=template&id=27a66a10&scoped=true&ts=true"
import script from "./MastZugaenglichkeit.vue?vue&type=script&lang=ts"
export * from "./MastZugaenglichkeit.vue?vue&type=script&lang=ts"

import "./MastZugaenglichkeit.vue?vue&type=style&index=0&id=27a66a10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a66a10"]])

export default __exports__